import { Container } from "pixi.js";
import { Manager } from "../Manager";


export interface IDisplayObject {
    labelName: string;
    anchorX: number;
    anchorY: number;
    landscape: {
        posX: number;
        posY: number;
        scale: number;
    };
    portrait: {
        posX: number;
        posY: number;
        scale: number;
    }
}

export class DisplayObject extends Container {
    constructor(protected config: IDisplayObject) {
        super();
        this.label = config.labelName;
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
    }
    public setPosition(posX = 100, posY = 100) {
        this.position.set(posX, posY);
    }

    public setScale(scaleX: number, scaleY: number) {
        return this.scale.set(scaleX, scaleY);
    }

    public getConfig(): IDisplayObject {
        return this.config;
    }

    public setPositionResize(orientation: string) {
        if (orientation === "LANDSCAPE") {
            this.setPosition(this.config.landscape.posX, this.config.landscape.posY);
            this.setScale(this.config.landscape.scale, this.config.landscape.scale);
        } else {
            this.setPosition(this.config.portrait.posX, this.config.portrait.posY);
            this.setScale(this.config.portrait.scale, this.config.portrait.scale);
        }
    }
}